/* eslint-disable camelcase */
import axios from 'axios';
import Photo from '../../../components/photo/Photo.vue';
import SaleTable from '../../sales/saleTable/SaleTable.vue';

/** Класс для проекта */
class Project {
  positions = [];

  name = '';

  address = '';

  sold_on = null;

  get stage_id() {
    return this.stage ? this.stage.id : null;
  }

  // eslint-disable-next-line class-methods-use-this
  set stage_id(stage_id) {
    //
  }

  get sold_on_local() {
    if (!this.sold_on) return null;

    const [year, month, day] = this.sold_on.split('-');
    return `${day}.${month}.${year}`;
  }

  // eslint-disable-next-line class-methods-use-this
  set sold_on_local(sold_on) {
    const [day, month, year] = sold_on.split('.');
    this.sold_on = `${year}-${month}-${day}`;
  }

  stage = {
    id: null,
  };

  title_page_documents_local = [];

  specification_documents_local = [];

  supporting_documents_local = [];

  other_documents_local = [];

  comment = null;
}
export default {
  components: {
    SaleTable,
    Photo,
  },
  props: ['action_id', 'id'],
  data() {
    return {
      projectMenu: false,
      activePicker: null,
      project: new Project(),
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        min: (v) => {
          if (v !== null && v !== undefined && Number(v) <= 0) {
            return 'Количество должно быть больше 0';
          }
          return true;
        },
      },
      accept: ['.pdf', 'image/png', 'image/jpeg', 'image/bmp'],
      searchProduct: '',
      isLoading: false,
      product: null,
      productsList: [],
      valid: true,
      profile: {},
      searchPoint: '',
      searchAddress: '',
      pointName: null,
      suggestions: [],
      isLoadingSuggest: false,
      stages: [],
      points: [],
      addresses: [],
      quantity: 0,
      tableHeaders: [
        { text: 'Название', value: 'name', sortable: false, align: 'left' },
        {
          text: 'Кол-во',
          value: 'quantity',
          sortable: false,
          align: 'center',
          width: 80,
        },
        { text: 'Бонусы', value: 'bonuses', sortable: false, align: 'center' },
        { text: '', value: 'actions', sortable: false, align: '' },
      ],
    };
  },
  watch: {
    searchProduct(product) {
      this.loadProducts(product);
    },
    searchAddress(address) {
      this.AutocompleteSearch(address);
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  created() {
    this.loadProducts();
  },
  computed: {
    /** Не добавленные ещё продукты */
    notAddedProducts() {
      const addedPositionsIds = this.project.positions.map(
        position => position.id,
      );
      return this.productsList.filter(
        product => !addedPositionsIds.includes(product.id),
      );
    },
    computedDateFormatted() {
      return this.FormatDate(this.project.sold_on);
    },
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.state.user;
    },
    // Возможность сохранить черновик
    draftEnabled() {
      return this.project.name && this.project.sold_on_local;
    },
    // Возможность сохранить объект
    sendEnabled() {
      return this.project.name && this.project.sold_on_local;
    },
    // Бонусы за добавляемую позицию
    bonuses() {
      //   TODO (quantity * product_bonuses) * stage_coeff
      return 0;
    },
    object() {
      return this.$store.state.objects.object;
    },
  },
  methods: {
    onStageSelect(stage_id) {
      const stage = this.stages.find(el => el.id === stage_id);
      if (stage) {
        this.project.stage = stage;
      }
    },
    /** Изменить позицию */
    changePosition(listID) {
      const position = this.project.positions.find(
        item => item.listID === listID,
      );
      this.deletePosition(listID);
      this.quantity = position.quantity;
      this.product = position;
    },
    /** Удалить позицию */
    deletePosition(listID) {
      this.project.positions = this.project.positions.filter(
        item => item.listID !== listID,
      );
    },
    /** Записать дату */
    SaveDate(date) {
      this.$refs.menu.save(date);
    },
    /** Форматировать дату */
    FormatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    setUniqueId() {
      return new Date().getTime();
    },
    AddProduct() {
      this.project.positions.push({
        ...this.product,
        quantity: this.quantity,
        listID: this.setUniqueId().toString(),
      });
      this.quantity = 0;
      this.product = null;
    },
    /** Получить список товаров */
    loadProducts(pattern = '') {
      const app = this;
      app.isLoading = true;
      app.$store.getters.ax
        .post('actions/api/action/get-sku-names', {
          search: pattern,
          type: 'name',
          action_id: +app.$props.action_id,
        })
        .then((response) => {
          if (
            response.data.products !== null
            && Array.isArray(response.data.products)
            && response.data.products.length
          ) {
            app.productsList = response.data.products;
          }
          app.isLoading = false;
        });
    },

    /** Отправка регистрационных данных в приложение */
    async register(isDraft = false) {
      const { project } = this;
      let valid = false;
      if (isDraft) {
        valid = project.name && project.sold_on;
      } else {
        valid = this.$refs.form.validate();
      }
      if (!valid) {
        return;
      }
      const app = this;
      const formData = {
        ...project,
        stage_id: this.project.stage_id,
        is_draft: isDraft,
        profile_id: this.user.profile_id,
        action_id: +this.$props.action_id,
      };

      app.$store.getters.axl
        .post('objects/api/objects/create', formData)
        .then(() => {
          app.$store.dispatch('ShowInfo', 'Проект зарегистрирован!');
          app.$router.push('/objects');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async GetStages() {
      const app = this;
      app.$store.getters.ax
        .post('objects/api/objects/stages')
        .then((result) => {
          app.stages = result.data.stages;
        });
    },
    AutocompleteSearch(queryString) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString, locations: { country: '*' } };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios
        .post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelect(item) {
      if (!item) {
        this.address_data = null;
      }
      this.suggestions.forEach((sug) => {
        if (sug.value === item) {
          this.address_data = sug.data;
        }
      });
    },
    /** Запретить вводить отрицательное значение в поле "Количество" */
    onQuantityKeydown(event) {
      const { key } = event;
      if (key === 'backspace' || key.toLowerCase().includes('arrow')) {
        return;
      }
      const quantityAsString = String(this.quantity);
      const zeroFirst = quantityAsString.length === 1 && quantityAsString === '0';
      const minus = key === '-';
      if (zeroFirst || minus) {
        event.stopPropagation();
        event.preventDefault();
      }
      const keyAsNumber = Number(key);
      if (zeroFirst && Number.isInteger(keyAsNumber)) {
        this.quantity = keyAsNumber;
      }
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    if (this.id && this.user) {
      this.$store
        .dispatch('objects/GetObject', {
          sale_object_id: this.id,
          profile_id: this.user.profile_id,
        })
        .then(() => {
          this.project = Object.assign(
            new Project(),
            this.$store.state.objects.object,
          );
          this.searchAddress = this.project.address;
        });
    }
    this.$store.dispatch('GetSettings');
    this.GetStages();
  },
};
